import { render, staticRenderFns } from "./basebrandAction.vue?vue&type=template&id=42d3fff2&scoped=true"
import script from "./basebrandAction.vue?vue&type=script&lang=js"
export * from "./basebrandAction.vue?vue&type=script&lang=js"
import style0 from "./basebrandAction.vue?vue&type=style&index=0&id=42d3fff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d3fff2",
  null
  
)

export default component.exports